import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { CatalogProvider } from '@/features/sync/CatalogProvider';
import { DownloadProvider } from '@/features/downloads/DownloadProvider';
import { MediaProvider } from '@/features/media/MediaProvider';
import { router } from '@/app/routes';

export function App(): React.ReactElement {
  return (
    <ErrorBoundary>
      <CatalogProvider>
        <MediaProvider>
          <DownloadProvider>
            <RouterProvider router={router} />
          </DownloadProvider>
        </MediaProvider>
      </CatalogProvider>
    </ErrorBoundary>
  );
}
